import { Toaster as Sonner } from '@vendor/sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                    description: 'group-[.toast]:text-muted-foreground',
                    actionButton:
                        'group-[.toast]:bg-background group-[.toast]:text-foreground',
                    cancelButton:
                        'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
                    // error: 'bg-red-400',
                    // success: 'text-green-400',
                    // warning: 'text-yellow-400',
                    // info: 'bg-blue-400',
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
